import moment from 'moment'

import { Policy } from '@/classes/models'

export default class User {
  /**
   * Create new user and set properties based on the given object.
   *
   * @param {Object} obj
   */
  constructor (obj) {
    Object.assign(this, obj)

    // Map policy structure to Policy
    if (typeof this.policyStructure !== 'undefined') {
      this.policyStructure = new Policy(this.policyStructure.cashFlowsPolicy)
    }
  }

  /**
   * @return {Boolean}
   */
  get accountIsLocked () {
    return !!this.lockoutEndDateUtc && moment.utc(this.lockoutEndDateUtc).isAfter()
  }
}
